import Platform from 'platform';

export function getPlatformInfo(page) {
    return {
        accessPath: page,
        browserName: Platform.name,
        browserVersion: Platform.version,
        clientProduct: Platform.product,
        clientArchitecture: `Family:${Platform.os.family}, Version:${Platform.os.version}, Architecture:${Platform.os.architecture}`,
    };
}
